import { useEffect, useState } from 'react';

import { cohortsApi } from '../api';
import type { CohortInfo } from '../types';

export interface UseCohortInfoResult {
  info: CohortInfo | null;
  loaded: boolean;
  errorStatus: number | null;
}

/**
 * Fetches the public join-landing info for a cohort (`GET
 * api/cohorts/v1/cohorts/<slug>/info/`, AllowAny). `errorStatus` is 404 for an
 * unknown/inactive slug.
 */
export function useCohortInfo(slug: string | undefined): UseCohortInfoResult {
  const [info, setInfo] = useState<CohortInfo | null>(null);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [errorStatus, setErrorStatus] = useState<number | null>(null);

  useEffect(() => {
    if (!slug) {
      return;
    }

    cohortsApi.getCohortInfo(
      slug,
      (data) => {
        setInfo(data);
        setLoaded(true);
      },
      (error) => {
        setErrorStatus((error as { status?: number })?.status ?? null);
        setLoaded(true);
      },
    );
  }, [slug]);

  return { info, loaded, errorStatus };
}
